/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React, {
  useEffect,
  useState
} from "react";

import { useParams } from "react-router-dom";

import Plot from "react-plotly.js";

import { fetchMFDetail } from "../api";

import NAV from "./nav";
import Carousel from "./carousel";

import MFFloatingAdvisorWidget
  from "../components/mf/MFFloatingAdvisorWidget";
import {Sparkles} from "lucide-react";
import MFSubnav from "../components/mf/MFSubnav";

import InvestModal from "../components/mf/InvestModal";
import MFInvestmentModal from "../components/mf/MFInvestmentModal";

const FundDetailPage = () => {

  const { isin } = useParams();

  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(true);

  const [showInvestModal, setShowInvestModal] = useState(false);

  // =====================================================
  // FETCH
  // =====================================================

  useEffect(() => {

    fetchMFDetail(isin)

      .then((res) => {

        setData(res);

        setLoading(false);

      })

      .catch((err) => {

        console.error(err);

        setLoading(false);

      });

  }, [isin]);


  // =====================================================
  // LOADING
  // =====================================================

  if (loading) {

    return (

      <div className="bg-[#f5f7f5] min-h-screen">

        <div className="container-fluid position-relative p-0">

          <NAV activetag="mf" />

          <Carousel activetag="mf" />
        <MFSubnav active="explorer" />

          <div className="container-fluid bg-breadcrumb">

            <div className="container text-center py-5">

              <h4
                className="
                  text-white
                  display-4
                  mb-4
                "
              >
                Mutual Fund Details
              </h4>

            </div>

          </div>

        </div>

        <div
          className="
            min-h-[60vh]
            flex
            items-center
            justify-center
            text-2xl
            font-bold
            text-green-900
          "
        >
          Loading Fund...
        </div>

      </div>

    );
  }


  // =====================================================
  // DATA
  // =====================================================

  const d = data.details[0];


  // =====================================================
  // REUSABLE CARD STYLE
  // =====================================================

  const premiumCard = `
    bg-white/90
    backdrop-blur-sm
    rounded-[32px]
    shadow-[0_10px_40px_rgba(0,0,0,0.06)]
    border
    border-gray-100
    p-8
    hover:-translate-y-1
    hover:shadow-[0_20px_50px_rgba(0,0,0,0.08)]
    transition-all
    duration-300
  `;


  // =====================================================
  // RENDER
  // =====================================================

  return (

    <div className="bg-[#f5f7f5] min-h-screen">

      {/* =====================================================
          NAV + HERO
      ===================================================== */}

      {/*<div className="container-fluid position-relative p-0">*/}

      {/*  <NAV activetag="mf" />*/}

      {/*  <Carousel activetag="mf" />*/}

      {/*  /!* HEADER *!/*/}

      {/*  <div className="container-fluid bg-breadcrumb">*/}

      {/*    <div className="container text-center py-5">*/}

      {/*      <div*/}
      {/*        className="*/}
      {/*          inline-flex*/}
      {/*          items-center*/}
      {/*          gap-3*/}
      {/*          bg-white/10*/}
      {/*          px-5*/}
      {/*          py-2*/}
      {/*          rounded-full*/}
      {/*          backdrop-blur-sm*/}
      {/*          mb-5*/}
      {/*        "*/}
      {/*      >*/}

      {/*        <span*/}
      {/*          className="*/}
      {/*            h-3*/}
      {/*            w-3*/}
      {/*            rounded-full*/}
      {/*            bg-green-300*/}
      {/*            animate-pulse*/}
      {/*          "*/}
      {/*        />*/}

      {/*        <span*/}
      {/*          className="*/}
      {/*            text-white*/}
      {/*            text-sm*/}
      {/*            font-semibold*/}
      {/*            tracking-wide*/}
      {/*          "*/}
      {/*        >*/}
      {/*          Institutional Grade Fund Analytics*/}
      {/*        </span>*/}

      {/*      </div>*/}

      {/*      <h1*/}
      {/*        className="*/}
      {/*          text-white*/}
      {/*          text-4xl*/}
      {/*          md:text-6xl*/}
      {/*          font-black*/}
      {/*          mb-4*/}
      {/*        "*/}
      {/*      >*/}
      {/*        Fund Intelligence*/}
      {/*      </h1>*/}

      {/*      <p*/}
      {/*        className="*/}
      {/*          text-green-100*/}
      {/*          text-lg*/}
      {/*          max-w-3xl*/}
      {/*          mx-auto*/}
      {/*        "*/}
      {/*      >*/}
      {/*        Deep mutual fund analytics,*/}
      {/*        performance intelligence,*/}
      {/*        volatility analysis and*/}
      {/*        risk-adjusted scoring powered*/}
      {/*        by Orion Analytics.*/}
      {/*      </p>*/}

      {/*    </div>*/}

      {/*  </div>*/}

      {/*</div>*/}

      <div className="relative">

        <NAV activetag="mf" />
    <div className="pt-[550px]">

        <Carousel activetag="mf" />

        {/* DARK OVERLAY */}

        <div
          className="
            absolute
            inset-0
            bg-gradient-to-b
            from-black/50
            via-black/40
            to-black/10
            pointer-events-none
          "
        />

        {/* HERO CONTENT */}

        <div
          className="
            absolute
            inset-0
            flex
            items-center
          "
        >

          <div
            className="
              w-full
              px-6
              lg:px-12
              xl:px-20
            "
          >

            <div className="max-w-4xl">

              <div
                className="
                  inline-flex
                  items-center
                  gap-2
                  px-4
                  py-2
                  rounded-full
                  bg-white/10
                  backdrop-blur-md
                  border
                  border-white/20
                  text-white
                  mb-6
                "
              >
                <Sparkles size={18} />
                Institutional Grade Fund Analytics
              </div>

              <h1
                className="
                  text-5xl
                  lg:text-7xl
                  font-black
                  text-white
                  leading-tight
                  mb-6
                "
              >
                Discover The Best
                <span className="block text-green-400">
                  Mutual Funds
                </span>
              </h1>

              <p
                className="
                  text-white/85
                  text-lg
                  lg:text-xl
                  leading-relaxed
                  max-w-2xl
                "
              >
                Deep mutual fund analytics,
                performance intelligence,volatility analysis and
                risk-adjusted scoring powered by Orion Analytics.
              </p>

            </div>

          </div>
        </div>
        </div>

      </div>
      {/* =====================================================
          MUTUAL NAV
      ===================================================== */}

      <div
        className="
          flex
          items-center
          gap-2
          text-sm
          text-gray-500
          mb-6
        "
      >

        <a
          href="/mf/"
          className="hover:text-green-700 font-semibold"
        >
          Mutual Funds
        </a>

        <span>/</span>

        <a
          href="/mfe/"
          className="hover:text-green-700 font-semibold"
        >
          Explorer
        </a>

        <span>/</span>

        <span className="text-gray-700 font-semibold">
          {d.canonical_name}
        </span>

      </div>
      {/* =====================================================
          FLOATING ADVISOR
      ===================================================== */}

      <MFFloatingAdvisorWidget />


      {/* =====================================================
          MAIN PAGE
      ===================================================== */}

        <div
          className="
            relative
            z-10
            max-w-[1600px]
            ml-4
            xl:ml-10
            2xl:ml-16
            mr-auto
            px-4
            md:px-8
            py-10
          "
        >

        {/* =====================================================
            FUND HERO
        ===================================================== */}

        <div
          className="
            relative
            overflow-hidden
            rounded-[42px]
            bg-gradient-to-br
            from-green-900
            via-green-700
            to-green-500
            p-8
            md:p-14
            text-white
            shadow-[0_20px_60px_rgba(0,128,0,0.18)]
            mb-10
          "
        >

          {/* GLOW */}

          <div
            className="
              absolute
              top-[-100px]
              right-[-100px]
              w-[350px]
              h-[350px]
              rounded-full
              bg-white/10
              blur-3xl
            "
          />

          <div
            className="
              relative
              z-10
              grid
              grid-cols-1
              lg:grid-cols-12
              gap-10
              items-center
            "
          >

            {/* LEFT */}

            <div className="lg:col-span-8">

              <div
                className="
                  flex
                  gap-3
                  flex-wrap
                  mb-6
                "
              >

                <div
                  className="
                    bg-white/15
                    px-4
                    py-2
                    rounded-full
                    text-sm
                    font-semibold
                    backdrop-blur-sm
                  "
                >
                  {d.category}
                </div>

                <div
                  className="
                    bg-white/15
                    px-4
                    py-2
                    rounded-full
                    text-sm
                    font-semibold
                    backdrop-blur-sm
                  "
                >
                  {d.sub_category}
                </div>

                <div
                  className="
                    bg-white/15
                    px-4
                    py-2
                    rounded-full
                    text-sm
                    font-semibold
                    backdrop-blur-sm
                  "
                >
                  {d.risk_grade} Risk
                </div>

              </div>


              <div
                className="
                  text-4xl
                  md:text-6xl
                  font-black
                  tracking-tight
                  leading-tight
                  mb-5
                "
              >
                {d.canonical_name}
              </div>


              <div
                className="
                  text-lg
                  opacity-90
                  mb-10
                "
              >
                AMC: {d.amc}
              </div>


              {/* METRICS */}

              <div
                className="
                  grid
                  grid-cols-2
                  md:grid-cols-4
                  gap-6
                "
              >

                <div>

                  <div
                    className="
                      uppercase
                      tracking-widest
                      text-xs
                      opacity-70
                      mb-2
                    "
                  >
                    Current NAV
                  </div>

                  <div className="text-3xl md:text-4xl font-black">
                    ₹{data.nav_history?.[0]?.nav || "--"}
                  </div>

                </div>


                <div>

                  <div
                    className="
                      uppercase
                      tracking-widest
                      text-xs
                      opacity-70
                      mb-2
                    "
                  >
                    1Y Return
                  </div>

                  <div className="text-3xl md:text-4xl font-black">
                    {d.return_1y || "--"}%
                  </div>

                </div>


                <div>

                  <div
                    className="
                      uppercase
                      tracking-widest
                      text-xs
                      opacity-70
                      mb-2
                    "
                  >
                    AUM
                  </div>

                  <div className="text-3xl md:text-4xl font-black">
                    ₹{d.aum || "--"}
                  </div>

                </div>


                <div>

                  <div
                    className="
                      uppercase
                      tracking-widest
                      text-xs
                      opacity-70
                      mb-2
                    "
                  >
                    Volatility
                  </div>

                  <div className="text-3xl md:text-4xl font-black">
                    {d.volatility || "--"}
                  </div>

                </div>

              </div>

            </div>


            {/* RIGHT CTA */}

            <div className="lg:col-span-4">

              <div
                className="
                  bg-white
                  rounded-[32px]
                  p-8
                  text-black
                  shadow-2xl
                "
              >

                <div
                  className="
                    text-sm
                    uppercase
                    tracking-widest
                    text-gray-400
                    mb-3
                  "
                >
                  Orion Score
                </div>


                <div
                  className="
                    flex
                    items-center
                    justify-center
                    mb-8
                  "
                >

                  <div
                    className="
                      w-40
                      h-40
                      rounded-full
                      border-[10px]
                      border-green-600
                      flex
                      flex-col
                      items-center
                      justify-center
                    "
                  >

                    <div
                      className="
                        text-5xl
                        font-black
                        text-green-700
                      "
                    >
                      {data.analytics_score?.score}
                    </div>

                    <div
                      className="
                        text-sm
                        text-gray-500
                        mt-1
                      "
                    >
                      Excellent
                    </div>

                  </div>

                </div>


                <button
                  onClick={() =>
                    setShowInvestModal(true)
                  }
                  className="
                    w-full
                    bg-green-700
                    hover:bg-green-800
                    text-white
                    py-4
                    rounded-2xl
                    font-bold
                    text-lg
                    mb-4
                    transition-all
                  "
                >
                  Invest Now
                </button>


                <button
                  onClick={() =>
                    setShowInvestModal(true)
                  }
                  className="
                    w-full
                    border-2
                    border-green-700
                    text-green-700
                    hover:bg-green-50
                    py-4
                    rounded-2xl
                    font-bold
                    text-lg
                    transition-all
                  "
                >
                  Start SIP
                </button>

              </div>

            </div>

          </div>

        </div>


        {/* =====================================================
            CHART + INTELLIGENCE
        ===================================================== */}

        <div
          className="
            grid
            grid-cols-1
            lg:grid-cols-12
            gap-8
            mb-10
          "
        >

          {/* CHART */}

          <div
            className={`
              ${premiumCard}
              lg:col-span-8
            `}
          >

            <div
              className="
                flex
                justify-between
                items-center
                mb-8
              "
            >

              <div>

                <div
                  className="
                    text-3xl
                    font-black
                    mb-2
                  "
                >
                  Performance Timeline
                </div>

                <div className="text-gray-500">
                  Long-term NAV growth trajectory
                </div>

              </div>

            </div>


            <Plot

              data={[

                {

                  x: data.nav_history.map(
                    i => i.nav_date
                  ),

                  y: data.nav_history.map(
                    i => i.nav
                  ),

                  type: "scatter",

                  mode: "lines",

                  line: {
                    width: 4,
                    color: "#16a34a",
                    shape: "spline"
                  },

                  fill: "tozeroy",

                  fillcolor:
                    "rgba(34,197,94,0.12)",

                }

              ]}

              layout={{

                autosize: true,

                height: 500,

                margin: {
                  l: 40,
                  r: 20,
                  t: 20,
                  b: 40
                },

                paper_bgcolor: "white",

                plot_bgcolor: "white",

                xaxis: {
                  gridcolor: "#f3f4f6"
                },

                yaxis: {
                  gridcolor: "#f3f4f6"
                }

              }}

              style={{
                width: "100%"
              }}

              config={{
                responsive: true,
                displayModeBar: false
              }}

            />

          </div>


          {/* ORION INTELLIGENCE */}

          <div
            className="
              lg:col-span-4
              rounded-[32px]
              p-8
              text-white
              bg-gradient-to-br
              from-green-900
              to-green-700
              shadow-[0_20px_60px_rgba(0,128,0,0.2)]
            "
          >

            <div
              className="
                text-3xl
                font-black
                mb-2
              "
            >
              Orion Intelligence
            </div>

            <div
              className="
                text-green-100
                mb-10
              "
            >
              Advanced Risk-Adjusted Scoring
            </div>


            <div className="space-y-8">

              <div
                className="
                  grid
                  grid-cols-2
                  gap-5
                "
              >

                <div>

                  <div
                    className="
                      uppercase
                      text-xs
                      tracking-widest
                      text-green-200
                      mb-2
                    "
                  >
                    Volatility
                  </div>

                  <div className="text-4xl font-black">
                    {d.volatility}
                  </div>

                </div>


                <div>

                  <div
                    className="
                      uppercase
                      text-xs
                      tracking-widest
                      text-green-200
                      mb-2
                    "
                  >
                    Risk Grade
                  </div>

                  <div className="text-4xl font-black">
                    {d.risk_grade}
                  </div>

                </div>

              </div>


              <div
                className="
                  border-t
                  border-white/20
                  pt-8
                "
              >

                <div
                  className="
                    text-green-100
                    leading-8
                    text-lg
                  "
                >
                  This fund demonstrates strong
                  long-term consistency with
                  healthy risk-adjusted
                  performance relative to
                  category peers.
                </div>

              </div>

            </div>

          </div>

        </div>


        {/* =====================================================
            RETURNS GRID
        ===================================================== */}

        <div
          className="
            grid
            grid-cols-2
            md:grid-cols-4
            lg:grid-cols-7
            gap-5
            mb-10
          "
        >

          {[
            ["1M", d.return_1m],
            ["3M", d.return_3m],
            ["6M", d.return_6m],
            ["1Y", d.return_1y],
            ["2Y", d.return_2y],
            ["3Y", d.return_3y],
            ["5Y", d.return_5y],
          ].map((item, idx) => (

            <div
              key={idx}
              className={premiumCard}
            >

              <div
                className="
                  uppercase
                  tracking-widest
                  text-xs
                  text-gray-400
                  mb-3
                "
              >
                {item[0]} Return
              </div>

              <div
                className="
                  text-4xl
                  font-black
                  text-green-700
                "
              >
                {item[1] || "--"}%
              </div>

            </div>

          ))}

        </div>


        {/* =====================================================
            RELATED FUNDS
        ===================================================== */}

        <div className={premiumCard}>

          <div
            className="
              flex
              justify-between
              items-center
              mb-8
            "
          >

            <div>

              <div
                className="
                  text-3xl
                  font-black
                  mb-2
                "
              >
                Similar Funds
              </div>

              <div className="text-gray-500">
                Comparable peer funds
              </div>

            </div>

          </div>


          <div
            className="
              grid
              md:grid-cols-2
              xl:grid-cols-3
              gap-5
            "
          >

            {data.related_funds.map((fund) => (

              <div
                key={fund.isin}
                className="
                  border
                  border-gray-100
                  rounded-[24px]
                  p-6
                  hover:border-green-300
                  transition-all
                "
              >

                <div
                  className="
                    text-xl
                    font-bold
                    mb-3
                  "
                >
                  {fund.canonical_name}
                </div>

                <div
                  className="
                    text-gray-500
                    mb-6
                  "
                >
                  {fund.risk_grade} Risk
                </div>


                <div
                  className="
                    flex
                    justify-between
                    items-center
                  "
                >

                  <div>

                    <div
                      className="
                        text-xs
                        uppercase
                        tracking-widest
                        text-gray-400
                        mb-1
                      "
                    >
                      1Y Return
                    </div>

                    <div
                      className="
                        text-3xl
                        font-black
                        text-green-700
                      "
                    >
                      {fund.return_1y}%
                    </div>

                  </div>


                  <a href={`/mfd/${fund.isin}`}>

                    <button
                      className="
                        bg-green-700
                        hover:bg-green-800
                        text-white
                        px-5
                        py-3
                        rounded-xl
                        font-semibold
                        transition-all
                      "
                    >
                      View
                    </button>

                  </a>

                </div>

              </div>

            ))}

          </div>

        </div>

      </div>
        {/*<InvestModal*/}
        {/*  open={showInvestModal}*/}
        {/*  onClose={() =>*/}
        {/*    setShowInvestModal(false)*/}
        {/*  }*/}
        {/*  fund={d}*/}
        {/*/>*/}
      <MFInvestmentModal
        open={showInvestModal}
        onClose={() =>
          setShowInvestModal(false)
        }
        fundName={d.canonical_name}
      />
    </div>

  );
};


export default FundDetailPage;